import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import '../styles/CookieBanner.scss';

const STORAGE_KEY = 'axiomatika_cookie_accepted';

function CookieBanner() {
    const intl = useIntl();
    const [visible, setVisible] = useState(() => {
        try {
            return localStorage.getItem(STORAGE_KEY) !== 'yes';
        } catch (error) {
            return true;
        }
    });

    const accept = () => {
        try {
            localStorage.setItem(STORAGE_KEY, 'yes');
        } catch (error) {
            // The banner still closes for this visit when storage is unavailable.
        }
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className='cookie-banner' aria-describedby='cookie-description' role='region' aria-label={intl.formatMessage({ id: 'cookieBannerLabel' })}>
            <div id='cookie-description'>
                {intl.formatMessage({ id: 'cookieBannerIntro' })}<br/>
                {intl.formatMessage({ id: 'cookieBannerConsent' })}
            </div>
            <div className='cookie-banner__actions'>
                <button className='cookie-banner__button cookie-banner__button--accept' type='button' onClick={accept}>
                    {intl.formatMessage({ id: 'cookieBannerAccept' })}
                </button>
                <a className='cookie-banner__button cookie-banner__button--details'
                    href='https://axiomatika.ru/person-dannye.php' target='_blank' rel='noopener noreferrer'>
                    {intl.formatMessage({ id: 'cookieBannerDetails' })}
                </a>
            </div>
        </div>
    );
}

export default CookieBanner;
